import parsePhoneNumber, { type CountryCode } from 'libphonenumber-js';

import { get } from '../helpers/settings';

export const parse = (tel: string, countryCode: CountryCode) => parsePhoneNumber(tel, countryCode);

export const INTERNATIONAL = 'INTERNATIONAL';
export const E164 = 'RFC3966';
export const NATIONAL = 'NATIONAL';

type obj = { [key: string]: undefined | number };

export const convert = (
  _phonenumber: string,
  getParams: (params: any) => void,
  callback: (v: string) => void,
) => {
  const phonenumber = _phonenumber.replaceAll(' ', '');
  if (process.env.SSR) {
    callback(phonenumber);
    return;
  }

  const aid = get('FreespeeId');

  if (!aid || !window.__fs_dncs_instance || !window.__fs_dncs_instance.getNumber) {
    callback(phonenumber);
    return;
  }

  getParams((params: obj) => {
    if (window.__fs_dncs_instance) {
      const fakeNode = document.createElement('span');
      document.body.appendChild(fakeNode);

      const checksum = phonenumber
        .slice(-4)
        .split('')
        .map((n) => Number.parseInt(n, 10))
        .reduce((sum, next) => sum + next, 0);
      const p = Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&');
      const onRequestSuccess = (_: any, result: { e164: string }) => {
        document.body.removeChild(fakeNode);
        callback(result.e164);
      };
      window.__fs_dncs_instance.getNumber(
        onRequestSuccess,
        fakeNode,
        phonenumber,
        aid,
        checksum,
        `&${p}`,
        null,
      );
    }
  });
};

export const initialize = () => {
  if (process.env.SSR || !window.__fs_dncs_instance) {
    return;
  }

  window.__fs_dncs_instance.loadEvent();
};
